//#region src/integrations/x/xTypes.ts
const X_INTEGRATION_ID = "x-integration";

//#endregion
export { X_INTEGRATION_ID };
//# sourceMappingURL=xTypes.js.map